module.exports = __webpack_public_path__ + "img/quality-2.4de6c0c5.jpg";